import { UserPermissionDefinitions } from "../models/UserPermissionsModel";

const DocMenuConfig = [
  {
    pages: [
      {
        heading: "Ana Sayfa",
        route: "/dashboard",
        svgIcon: "media/icons/duotune/art/art002.svg",
        fontIcon: "bi-app-indicator",
      },
    ],
  },
];

export default DocMenuConfig;
